import { useEffect, useState } from 'react';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

import {
  disabledGray,
  primaryBlue,
  successGreen,
} from '../../constants/colors';
import { IItemStatus } from '../../type';
import { getItemColor, getWindowDimensions } from '../../utils/helpers';

interface IProps {
  closingDate?: string;
  title: string;
  active: boolean;
  cardItems: IItemStatus[];
  zIndex?: any;
  onSaActionsClick: (item: IItemStatus, index: any) => void;
  id: string;
}

function ActionCardSALP(props: IProps) {
  const {
    active,
    cardItems,
    title,
    closingDate,
    zIndex,
    onSaActionsClick,
    id,
  } = props;
  const windowSize = getWindowDimensions().width;
  const marginTop = windowSize > 1024 ? 0 : 1.5;
  const fontSize = windowSize > 1024 ? 20 : 14;
  const listFontSize = windowSize > 1024 ? 17 : 14;
  const [allComplete, setAllComplete] = useState(false);

  useEffect(() => {
    const allItemsCompleted = cardItems.every((item) => item.completed);
    if (allItemsCompleted) {
      setAllComplete(true);
    }
  }, [cardItems]);

  return (
    <>
      <Grid
        zIndex={zIndex ? zIndex : 0}
        item
        xs={8}
        sm={8}
        md={3.5}
        lg={3.55}
        sx={{
          backgroundColor: 'white',
          marginRight: 2,
          border: 2,
          borderColor: allComplete
            ? successGreen
            : active
            ? primaryBlue
            : disabledGray,
          borderRadius: 1,
          marginTop: marginTop,
        }}>
        <Grid container>
          <Grid
            data-testid={id}
            item
            xs={12}
            sx={{
              padding: 1.5,
              backgroundColor: allComplete
                ? successGreen
                : active
                ? primaryBlue
                : disabledGray,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <Typography
              sx={{ fontSize: fontSize, fontWeight: 'bold', color: 'white' }}>
              {title}
            </Typography>
            {closingDate && (
              <Typography
                sx={{ fontSize: fontSize, fontWeight: 'bold', color: 'white' }}>
                {closingDate + ')'}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <List>
              {cardItems.map((item, index) => (
                <ListItem
                  key={index}
                  dense
                  onClick={() => {
                    if (!item.disabled) {
                      onSaActionsClick(item, index);
                    }
                  }}
                  sx={{
                    color: getItemColor(
                      cardItems[index].completed,
                      cardItems[index].disabled,
                      true
                    ),
                  }}
                  secondaryAction={
                    <IconButton aria-label='comment'>
                      {!cardItems[index].completed ? (
                        <RadioButtonUncheckedIcon />
                      ) : (
                        <CheckCircleIcon color='success' />
                      )}
                    </IconButton>
                  }>
                  <ListItemButton disabled={item.disabled}>
                    <Box
                      textAlign='left'
                      style={{ paddingRight: 3 }}
                      sx={{ fontSize: listFontSize, fontWeight: 600 }}>
                      {item.name}
                    </Box>
                    <ListItemText
                      secondaryTypographyProps={{
                        align: 'left',
                        alignSelf: 'center',
                        display: 'flex',
                      }}
                      secondary={
                        !item.disabled && <ArrowRightIcon color='primary' />
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ActionCardSALP;
